export enum JobTypeValues {
  AR = "AR",
  VR = "VR",
  MATTERPORT = "MATTERPORT",
  NEWSLETTER = "NEWSLETTER",
  RENDERED_VT = "RENDERED_VT",
}
